
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPiezoelectricCrystalOff as ObiPiezoelectricCrystalOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-piezoelectric-crystal-off.js';
 
 
 

 
 export const ObiPiezoelectricCrystalOff = createComponent({
   react: React,
   tagName: 'obi-piezoelectric-crystal-off',
   elementClass: ObiPiezoelectricCrystalOffElement,
   events: {
     
   }
  });
 
 